<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <p-toast key="toastmsg" position="top-right"></p-toast>
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <form [formGroup]="featuredThisWeekForm" *ngIf="this.featuredThisWeekForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    {{pagetitle}}
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4">
                                    <label for="title">Title<span class="mandatory-feilds">*</span></label>
                                    <input id="title" formControlName="title" type="text" pInputText
                                        [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                                    <div *ngIf="((submitted && f.title.errors) || (f.title.errors && (f.title.dirty || f.title.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.title.errors.required">Title is required</div>
                                    </div>
                                </div>
                                <div class="p-fluid  p-col-4 p-formgrid p-grid">
                                    <div class="p-field p-col-12">
                                        <label for="link">Link <span class="mandatory-feilds">*</span></label>
                                        <input formControlName="link" id="link" type="text" pInputText
                                            [ngClass]="{ 'is-invalid': submitted && f.link.errors }" class="form-control" autocomplete="off">
                                        <div *ngIf="((submitted && f.link.errors) || (f.link.errors && (f.link.dirty || f.link.touched)))"
                                            class="invalid-feedback">
                                            <div *ngIf="f.link.errors.required">Link is required</div>
                                        </div>
                                    </div>
                                </div>



                                     <div class="p-field p-col-4 p-0">
                                    <div class="p-field p-col">
                                          <div class="statusdiv ">
                                            <label for="status">Status</label>
                                           <div class="swichTable">
                                            <p-inputSwitch class="checkbox-mt-10" formControlName="status"
                                                [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                                            </div>
                                        </div>
<!--                                         
                                        <label for="status">Status</label>
                                        <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                            placeholder="Select" optionLabel="label"
                                            (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                            <div *ngIf="f.status.errors.required">Please Select Status</div>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="p-field p-col-8">
                                    <label>Description<span class="mandatory-feilds">*</span></label>
                                    <textarea inputId="textarea" formControlName="description" rows="5" cols="30" class="form-control"
                                        pInputTextarea [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                    <div *ngIf="((submitted && f.description.errors) || (f.description.errors && (f.description.dirty || f.description.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.description.errors.required">Description is required</div>
                                    </div>
                                </div>
                                         <div class="p-field p-col-4 calederForm"> 
                                        <label for="date">Date<span class="mandatory-feilds">*</span></label>
                                        <p-calendar formControlName="date" monthNavigator="true" yearNavigator="true"
                                            yearRange="{{yearRange}}" dateFormat="dd-mm-yy" [showIcon]="true"
                                            [ngClass]="{ 'is-invalid': submitted && f.date.errors }"></p-calendar>
                                        <div *ngIf="((submitted && f.date.errors) || (f.date.errors && (f.date.dirty || f.date.touched)))"
                                            class="invalid-feedback">
                                            <div *ngIf="f.date.errors.required">Date is required</div>
                                        </div> 
                                         </div>
                                          <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>

                              <div class="p-field p-col-12 uploadBtn">
                                    <div class="subTitleLable">
                                        <h4>Upload Featured This Week Image</h4>
                                    </div>
                                    <p-fileUpload #fileUpload mode="advanced" name="file" chooseLabel="Upload Image"
                                        accept="image/*" [maxFileSize]="imageSize" [auto]="false" [customUpload]="true"
                                        [showUploadButton]="false" [showCancelButton]="false"
                                        (onSelect)="onFileSelect($event)" (onRemove)="removeFile($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload>
                                    <div class="error-msg" *ngIf="notproduct">
                                        Please Upload Featured this Week Image
                                    </div>
                                    <div class="column banner-images col mt-4"
                                        *ngIf="showExistingFeaturedImage && featuredThisWeekImage">
                                        <img class="thumbnail-image" [src]="featuredThisWeekImage" />
                                        <ul class="actionList">
                                            <li>
                                                <button type="button" class="editBtn" (click)="fileUpload.choose()"><img
                                                        src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                            </li>
                                            <li>
                                                <button type="button" class="deleteBtn" (click)="removeFeaturedThisWeekImage()"><img
                                                        src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="instruction mt-3">
                                        <p>Instructions: </p>
                                        <ul>
                                             <li>The Feature of the Week image must be exactly 736px width and 840px height for proper display. </li>
                                            <li>Keep the file size optimized for fast loading and better performance, with a maximum size of 1 MB. </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- <div class="p-fluid p-formgrid p-grid baner-image-update" *ngIf="featuredThisWeekImage">
                                    <div class="p-field p-col-12">
                                        <h3 class="mb-0">Featured this Week Image</h3>
                                    </div>
                                    <div class="p-field p-col-12">
                                        <button type="button" class="banner_trash-btn" pButton pRipple
                                            icon="pi pi-trash" (click)="removeFeaturedThisWeekImage()"
                                            title="Delete"></button>
                                        <div class="row">
                                            <img class="thumbnail-image" [src]="featuredThisWeekImage" />
                                        </div>
                                    </div>
                                </div> -->
                            </div>

                             
                            <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer mt-5">
                                <div class="p-formgrid p-grid">
                                    <p-toast></p-toast>
                                    <button type="button" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                        class="p-button-success save-btn p-mr-3" style="width: auto"
                                        [disabled]="isSubmitting"></button>
                                    <button type="button" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                                        class="p-button-danger cancel-btn" style="width: auto"></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    
        </div>
    </div>
    <p-dialog
        [(visible)]="cropDialog"
        [closable]="true"
        (onHide)="onDialogHide()"
        [modal]="true"
        [appendTo]="'body'"
        [style]="{width: '720px'}"
        [breakpoints]="{'768px': 'calc(100vw - 24px)'}"
        styleClass="custom-crop-dialog">
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
                    <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
                </div>
            </div>
        </ng-template>

        <div class="crop-dialog-content-wrapper">
            <div class="crop-toolbar-bar mb-3">
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
                <div class="zoom-actions">
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
                        (click)="zoomIn()"></button>
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
                        (click)="zoomOut()"></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
                        (click)="resetZoom()"></button>
                </div>
            </div>

            <div class="cropper-frame mb-3">
                <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="736 / 840"
                    [resizeToWidth]="736"
                    [resizeToHeight]="840"
                    [onlyScaleDown]="false"
                    [imageQuality]="92"
                    [backgroundColor]="'#ffffff'"
                    [transform]="transform"
                    format="jpeg"
                    (imageCropped)="imageCropped($event)"
                    (loadImageFailed)="onCropImageLoadFailed()">
                </image-cropper>
            </div>

            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                <span>{{croppedImageError}}</span>
            </div>

            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Featured Image Preview" class="preview-img" />
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times"
                    class="cancel-action-btn" (click)="onCropCancel()"></button>
                <button type="button" pButton label="Use Image" icon="pi pi-check"
                    class="use-image-btn" (click)="applyCrop()"
                    [disabled]="isApplyingCrop || !!croppedImageError || !croppedImage"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>

  <p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>

